import { isNil, mergeWith, mapValues } from 'lodash';
import constants from '@/store/modules/address/constants';

const emptyAddress = {
  companyName: '',
  street: '',
  city: '',
  state: '',
  zipCode: '',
};

function getAddressProps(target) {
  let address = {
    companyName: target.companyName,
    street: target.street,
    city: target.city,
    state: target.state,
    zipCode: target.zipCode,
  };

  address = mapValues(address, (p) => (isNil(p) ? '' : p));

  return address;
}

export default {
  [constants.mutationTypes.start](state) {
    state.editingObject = getAddressProps(state);
  },

  [constants.mutationTypes.change](state, { key, value }) {
    state.editingObject = {
      ...state.editingObject,
      [key]: value,
    };
  },

  [constants.mutationTypes.cancel](state) {
    state.editingObject = null;
  },

  [constants.mutationTypes.save](state) {
    const addr = getAddressProps(state.editingObject);
    mergeWith(state, addr);
    state.editingObject = null;
  },

  [constants.mutationTypes.load](state, address) {
    const addr = address === null
      ? emptyAddress
      : getAddressProps(address);
    mergeWith(state, addr);
  },
};
